import { PurchasedProductInterface } from 'outshared-lib';
import { CoverageGroupTypeEnum } from '../enums';
import { CoverageControlConfigGroupInterface } from '../interfaces';
import { CoverageGroupAbstract } from './coverage-group.abstract';

export class CoverageGroupDynamic extends CoverageGroupAbstract {
    constructor(
        group: CoverageControlConfigGroupInterface,
        purchasedProduct: PurchasedProductInterface,
    ) {
        if (!group.inputs.find((input) => input.dependsOn)) {
            throw new Error('GroupDynamic must have inputs with dependencies');
        }

        super(CoverageGroupTypeEnum.Dynamic, group, purchasedProduct);
    }
}
